import { ValidatorFn } from '@angular/forms';

export const birthDateValidator: ValidatorFn = (control) => {
  const year = control.get('year');
  const month = control.get('month');
  const date = control.get('date');
  if (!(year && month && date)) {
    return { invalidField: true };
  }
  if (!(year.value && month.value && date.value)) {
    return { noBirthDate: '生年月日を正しく選択してください。' };
  }
  return null;
};
